export default "__VITE_ASSET__42635bd0__"